module.exports = __webpack_public_path__ + "img/desktop-icon.23628016.svg";